import React from 'react';
import { useTheme } from '@material-ui/core';

const DuplicateTabsIcon = () => {
  const {
    palette: { primary, error },
  } = useTheme();

  return (
    <svg
      width="102"
      height="96"
      viewBox="0 0 102 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2602_156160)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.09608 65.4166C4.82941 67.1389 6.93791 68 9.42157 68H16.5V83.1219C16.5 85.5935 17.3654 87.6917 19.0961 89.4166C20.8294 91.1389 22.9379 92 25.4216 92H70.7288C67.3712 89.7676 64.608 86.7123 62.7271 83.1219H25.4216V36.878H60.4216V52.1951H70.4399C74.2979 49.5486 78.9681 48 84 48C88.5794 48 92.8593 49.2826 96.5 51.5082V36.878C96.5 34.4065 95.6346 32.3083 93.9039 30.5834C92.1706 28.8611 90.0621 28 87.5784 28H80.5V12.878C80.5 10.4065 79.6346 8.30829 77.9039 6.58341C76.1706 4.86114 74.0621 4 71.5784 4H9.42157C6.93791 4 4.82941 4.86114 3.09608 6.58341C1.36536 8.30829 0.5 10.4065 0.5 12.878V59.1219C0.5 61.5935 1.36536 63.6917 3.09608 65.4166ZM16.5 36.878V59.1219H9.42157V12.878H44.4216V28H25.4216C22.9379 28 20.8294 28.8611 19.0961 30.5834C17.3654 32.3083 16.5 34.4065 16.5 36.878Z"
          fill={primary.main}
        />
      </g>
      <rect x="65.5" y="54" width="36" height="36" rx="18" fill={error.main} />
      <path
        d="M81.1375 75.5624V60.3374H85.8624V75.5624H81.1375ZM81.1375 83.6624V78.9374H85.8624V83.6624H81.1375Z"
        fill={error.light}
      />
      <defs>
        <clipPath id="clip0_2602_156160">
          <rect width="96" height="96" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DuplicateTabsIcon;
